export default __webpack_public_path__ + "static/media/travel-care-4.b5f20605.svg";